import { render, staticRenderFns } from "./ContributorsTab.vue?vue&type=template&id=0b98e7ed&"
import script from "./ContributorsTab.vue?vue&type=script&lang=js&"
export * from "./ContributorsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports